import React from 'react';
import MusicAlbumReleaseStepsView from './MusicAlbumReleaseStepsView';
import { MusicDistributionClientContext } from '../../context/MusicDistributionClientContext';
import MusicAlbumEditForm3ListView from './MusicAlbumEditForm3ListView';
import MusicAlbumEditForm3IncompletePopup from './MusicAlbumEditForm3IncompletePopup';
import MusicAlbumEditForm3EditPopup from './MusicAlbumEditForm3EditPopup';
import MusicAlbumCorrectionRequestView from './MusicAlbumCorrectionRequestView';
import CustomButton from '../../../common/components/CustomButton';
import ErrorMessage from '../../../common/components/ErrorMessage';
import { MusicAlbumArtistEntity, MusicAlbumEntity, MusicAlbumTrackEntity } from '../../types/MusicAlbumEntityTypes';
import { MusicComposerEntity, MusicEntity, MusicFeaturingArtistEntity, MusicLyricWriterEntity, MusicPerformanceRoleEntity, MusicProductionAndEngineeringRoleEntity } from '../../types/MusicEntityTypes';
import { TunecoreReleaseTrackEntity } from '../../types/TunecoreReleaseEntityTypes';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';


type ExtendedMusicAlbumEntity = MusicAlbumEntity & {
  music_album_artists: MusicAlbumArtistEntity[],
  music_album_tracks: ExtendedMusicAlbumTrackEntity[],
};
type ExtendedMusicEntity = MusicEntity & {
  music_featuring_artists: MusicFeaturingArtistEntity[],
  music_composers: MusicComposerEntity[],
  music_lyric_writers: MusicLyricWriterEntity[],
  music_production_and_engineering_roles: MusicProductionAndEngineeringRoleEntity[],
  music_performance_roles: MusicPerformanceRoleEntity[],
  tunecore_release_track: TunecoreReleaseTrackEntity,
};
type ExtendedMusicAlbumTrackEntity = MusicAlbumTrackEntity & {
  music: ExtendedMusicEntity,
};

export default function MusicAlbumEditForm3({
  musicAlbum,
  performanceRoleOptions,
  productionAndEngineeringRoleOptions,
} : {
  musicAlbum: ExtendedMusicAlbumEntity,
  performanceRoleOptions: { text: string, value: string }[],
  productionAndEngineeringRoleOptions: { text: string, value: string }[],
}) {
  const [musicAlbumTracks, setMusicAlbumTracks] = React.useState(musicAlbum.music_album_tracks);
  const [selectedMusicAlbumTrack, setSelectedMusicAlbumTrack] = React.useState<ExtendedMusicAlbumTrackEntity|null>(null);
  const [popup, setPopup] = React.useState<'edit'|'incomplete'|null>(null);
  const [errors, setErrors] = React.useState<{[key: string]: FieldValidationErrorsType}>({});
  const {
    getMusicAlbumTracks,
    validateEditedMusicAlbumTracks,
  } = React.useContext(MusicDistributionClientContext);

  const reloadMusics = () => {
    getMusicAlbumTracks(musicAlbum.id).then((data) => {
      setMusicAlbumTracks(data.musicAlbumTracks);
    });
  };

  const handleSubmit = () => {
    // eslint-disable-next-line max-len
    if (musicAlbumTracks.filter((musicAlbumTrack) => !musicAlbumTrack.is_distributable).length !== 0) {
      setPopup('incomplete');
      return;
    }
    validateEditedMusicAlbumTracks(musicAlbum.id).then((data) => {
      if (data.result) {
        document.location.href = `/music_albums/confirm/${musicAlbum.id}`;
      } else {
        setErrors(data.validationErrors as { [key: string]: FieldValidationErrorsType });
      }
    });
  };

  return (
    <>
      <MusicAlbumReleaseStepsView
        step={3}
        musicAlbum={musicAlbum}
        onClick={(callback) => { callback(musicAlbum.id); }}
      />
      <MusicAlbumCorrectionRequestView musicAlbum={musicAlbum} />
      <form className="music_list">
        <MusicAlbumEditForm3ListView
          musicAlbumTracks={musicAlbumTracks}
          onEdit={(musicAlbumTrack) => { setSelectedMusicAlbumTrack(musicAlbumTrack); setPopup('edit'); }}
        />
        <ul>
          <li className="bt">
            <CustomButton type="cancel-split" onClick={() => { document.location.href = `/music_albums/select_tracks/${musicAlbum.id}`; }}>戻る</CustomButton>
            <CustomButton type="default-split" onClick={() => { handleSubmit(); }}>次へ</CustomButton>
          </li>
        </ul>
        <div className="form__body">
          <ErrorMessage type="error" validationErrors={errors.id} />
        </div>
      </form>
      {popup === 'edit' && selectedMusicAlbumTrack !== null && (
        <MusicAlbumEditForm3EditPopup
          music={selectedMusicAlbumTrack.music}
          musicAlbum={musicAlbum}
          onDone={() => { setPopup(null); setSelectedMusicAlbumTrack(null); reloadMusics(); }}
          onCancel={() => { setPopup(null); setSelectedMusicAlbumTrack(null); }}
          productionAndEngineeringRoleOptions={productionAndEngineeringRoleOptions.map((option) => ({ title: option.text, value: option.value }))}
          performanceRoleOptions={performanceRoleOptions.map((option) => ({ title: option.text, value: option.value }))}
        />
      )}
      {popup === 'incomplete' && (
        <MusicAlbumEditForm3IncompletePopup
          onClose={() => { setPopup(null); }}
        />
      )}
    </>
  );
}
